import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { WhyChoose } from "@/components/WhyChoose";
import { Team } from "@/components/Team";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Process />
      <WhyChoose />
      <Team />
      <Testimonials />
      <FAQ />
      <Contact />
    </main>
  );
}
